import React, { useState } from 'react';
import logoWhite from '../../assets/images/LogoFocoSegWhite.png';
import logoFocoSeg from '../../assets/images/focoseg-color.png';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className='bg-white text-teal-900 py-4 relative shadow'>
      <div className='container mx-auto px-4'>
        <div className='flex justify-between items-center'>
          <div className='flex-1 md:flex-none flex justify-center md:justify-start'>
            <img src={logoFocoSeg} alt='FocoSeg Logo' className='h-12' />
          </div>
          
          <nav className='hidden md:block'>
            <ul className='flex space-x-6'>
              <li><a href='#servicos' className='hover:text-emerald-600 transition-colors'>Serviços</a></li>
              <li><a href='#diferenciais' className='hover:text-emerald-600 transition-colors'>Diferenciais</a></li>
              <li><a href='#esocial' className='hover:text-emerald-600 transition-colors'>eSocial</a></li>
              <li><a href='#treinamentos' className='hover:text-emerald-600 transition-colors'>Treinamentos</a></li>
              <li><a href='https://focoseg.com.br/contadorparceiro/#' target='_blank' rel='noopener noreferrer' className='hover:text-emerald-600 transition-colors'>Contador Parceiro</a></li>
              <li><a href='https://focoseg.com.br/condominioslp' target='_blank' rel='noopener noreferrer' className='hover:text-emerald-600 transition-colors'>Condomínios</a></li>
              <li><a href='https://focoseg.com.br/clienteparceiro/#' target='_blank' rel='noopener noreferrer' className='hover:text-emerald-600 transition-colors'>Cliente Parceiro</a></li>
              <li><a href='#sobre' className='hover:text-emerald-600 transition-colors'>Sobre</a></li>
              <li><a href='#contato' className='hover:text-emerald-600 transition-colors'>Contato</a></li>
            </ul>
          </nav>

          {/* Mobile menu button */}
          <button 
            className="md:hidden absolute right-4 top-1/2 -translate-y-1/2"
            onClick={toggleMobileMenu}
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="h-6 w-6" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              {isMobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile menu */}
        {isMobileMenuOpen && (
          <nav className='md:hidden mt-4 pb-4'>
            <ul className='flex flex-col items-center space-y-4'>
              <li><a href='#servicos' className='hover:text-emerald-600 text-teal-900' onClick={toggleMobileMenu}>Serviços</a></li>
              <li><a href='#diferenciais' className='hover:text-emerald-600 text-teal-900' onClick={toggleMobileMenu}>Diferenciais</a></li>
              <li><a href='#esocial' className='hover:text-emerald-600 text-teal-900' onClick={toggleMobileMenu}>eSocial</a></li>
              <li><a href='#treinamentos' className='hover:text-emerald-600 text-teal-900' onClick={toggleMobileMenu}>Treinamentos</a></li>
              <li><a href='https://focoseg.com.br/contadorparceiro/#' target='_blank' rel='noopener noreferrer' className='hover:text-emerald-600 text-teal-900' onClick={toggleMobileMenu}>Contador Parceiro</a></li>
              <li><a href='https://focoseg.com.br/condominioslp' target='_blank' rel='noopener noreferrer' className='hover:text-emerald-600 text-teal-900' onClick={toggleMobileMenu}>Condomínios</a></li>
              <li><a href='https://focoseg.com.br/clienteparceiro/#' target='_blank' rel='noopener noreferrer' className='hover:text-emerald-600 text-teal-900' onClick={toggleMobileMenu}>Cliente Parceiro</a></li>
              <li><a href='#sobre' className='hover:text-emerald-600 text-teal-900' onClick={toggleMobileMenu}>Sobre</a></li>
              <li><a href='#contato' className='hover:text-emerald-600 text-teal-900' onClick={toggleMobileMenu}>Contato</a></li>
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;